import { paramDecode, paramText, paramType } from '../constants/parameterNames';
import { typeBoolean, typeOption } from '../constants/parameterTypes';
import {
    getBoolParamValue,
    getParamValue,
} from '../helpers/parameter.accessors';

const $ = window.jQuery;

const requiredParameters = {
    [paramText]: 'text to encode',
};
const optionalParameters = {
    [paramDecode]: {
        description: '(boolean, defaults to false) Decode the text',
        type: typeBoolean,
    },
    [paramType]: {
        description:
            'Encoding type (url | html | uri | uriComponent); default is url',
        type: typeOption,
        options: [
            {
                name: 'Url',
                value: 'url',
            },
            {
                name: 'Html',
                value: 'html',
            },
            {
                name: 'Uri',
                value: 'uri',
            },
            {
                name: 'Uri Component',
                value: 'uriComponent',
            },
        ],
        value: 'url',
    },
};

const description = 'Returns an encoded or decoded string.';

const prepareTypeParamError = (type) =>
    new Error(`Unknown value for /${paramType} parameter: ${type}`);

const encodeHtml = (text) => $('<n />').text(text).html();

function performEncode(text, type) {
    switch (type) {
        case 'url':
        case 'uri':
            return encodeURI(text);
        case 'html':
            return encodeHtml(text);
        case 'uriComponent':
            return encodeURIComponent(text);
        default:
            throw prepareTypeParamError(type);
    }
}

const decodeHtml = (text) => $('<n />').html(text).text();

function performDecode(text, type) {
    switch (type) {
        case 'url':
        case 'uri':
            return decodeURI(text);
        case 'html':
            return decodeHtml(text);
        case 'uriComponent':
            return decodeURIComponent(text);
        default:
            throw prepareTypeParamError(type);
    }
}

const execute = ({ parameters }) => {
    const text = getParamValue(parameters, paramText);
    const type = getParamValue(parameters, paramType, 'url');
    const decode = getBoolParamValue(parameters, paramDecode);

    return decode ? performDecode(text, type) : performEncode(text, type);
};

const Encode = {
    description,
    execute,
    requiredParameters,
    optionalParameters,
};

export default Encode;
